function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _defs, _g;
var _excluded = ["width", "height", "originalSize", "top", "bottom", "left", "right"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
var toUnit = function toUnit(v) {
  return !v || /^([0-9]+(px|em|rem|%)|auto)/.test(v) ? v : v + 'px';
};
var SvgSharedLaundry = function SvgSharedLaundry(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? '35px' : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '35px' : _ref$height,
    originalSize = _ref.originalSize,
    top = _ref.top,
    bottom = _ref.bottom,
    left = _ref.left,
    right = _ref.right,
    rest = _objectWithoutProperties(_ref, _excluded);
  var hasStyle = !!top || !bottom || !!right || !!left;
  var style = hasStyle ? {
    marginTop: toUnit(top),
    marginBottom: toUnit(bottom),
    marginRight: toUnit(right),
    marginLeft: toUnit(left)
  } : {};
  var props = originalSize ? _objectSpread(_objectSpread({}, rest), {}, {
    style: style
  }) : _objectSpread(_objectSpread({}, rest), {}, {
    style: style,
    width: toUnit(width),
    height: toUnit(height)
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "shared_laundry_svg__a",
    d: "M8.716 8.992c0-.548.44-.992 1.002-.992h-.535c1.491 0 2.841 1.206 3.014 2.677l1.921 16.331a.87.87 0 0 1-.883.992h-3.52c-.552 0-1-.455-1-.992V8.992Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 10)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#494949",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M35.042 11.7 31.714 27H5.286L1.958 11.7h-.95A1.004 1.004 0 0 1 0 10.695v-.69A1 1 0 0 1 1.009 9H35.99c.558 0 1.01.446 1.01 1.005v.69a1 1 0 0 1-1.009 1.005h-.949Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#494949",
    d: "m6.522 11.907.569 3.413c.051.306.362.57.668.57h2.499c.24 0 .379-.164.339-.406l-.57-3.413a.72.72 0 0 0-.668-.571H6.861c-.24 0-.38.165-.339.407Zm29.82-.998-.67 4.018c-.05.302-.367.573-.672.573h-3c-.245 0-.382-.164-.342-.409l.67-4.018c.05-.302.367-.573.672-.573h3c.245 0 .382.164.342.409Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.492,
    height: 4.391,
    x: 13.5,
    y: 11.5,
    stroke: "#494949",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.492,
    height: 4.391,
    x: 19.5,
    y: 11.5,
    stroke: "#494949",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.492,
    height: 4.391,
    x: 13.5,
    y: 19.5,
    stroke: "#494949",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.492,
    height: 4.391,
    x: 19.5,
    y: 19.5,
    stroke: "#494949",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#494949",
    d: "m6.522 19.907.569 3.413c.051.306.362.57.668.57h2.499c.24 0 .379-.164.339-.406l-.57-3.413a.72.72 0 0 0-.668-.571H6.861c-.24 0-.38.165-.339.407Zm23.075-8-.57 3.413a.718.718 0 0 1-.668.57h-2.498c-.24 0-.38-.164-.339-.406l.569-3.413c.051-.306.362-.571.668-.571h2.499c.24 0 .379.165.339.407Zm0 8-.57 3.413a.718.718 0 0 1-.668.57h-2.498c-.24 0-.38-.164-.339-.406l.569-3.413c.051-.306.362-.571.668-.571h2.499c.24 0 .379.165.339.407Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#494949",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M35.036 4h-6.021L29 30.31h13.864c1.653 0 2.8-1.339 2.567-2.962 0 0-1.52-10.34-2.062-15.714-.422-3.267-2.178-4.82-3.037-5.374C37.925 4.44 35.036 4 35.036 4Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#shared_laundry_svg__a",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#494949",
    d: "M9.545 8.529a.524.524 0 0 1 .173-.029v-1h-.535v1c.122 0 .243.01.362.029Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#494949",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M29 2.2h5v1.764h-5zm1-2h2.5v1.764H30z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    stroke: "#494949",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 14a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 10a2 2 0 0 0-2-2"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    stroke: "#494949",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 7A1.5 1.5 0 0 0 26 5.5"
  })))));
};
export { SvgSharedLaundry as ReactComponent };
export default "/_next/static/media/shared_laundry.49c64576.svg";